import { LoadingSpinner } from '@workspace/ui/components/loading-spinner'
import { cn } from '@workspace/ui/lib/utils'
import type { ReactNode } from 'react'

export interface SpinnerRowProps {
  children: ReactNode
  className?: string
}

/**
 * A spinner beside a sentence explaining what is being waited on.
 *
 * The sentence carries the meaning, so the spinner is hidden from assistive
 * tech — otherwise `LoadingSpinner`'s own "Loading..." is announced on top of
 * it and the user hears the wait twice without learning what it is for.
 */
export function SpinnerRow({ children, className }: SpinnerRowProps) {
  return (
    <div className={cn('flex items-center gap-3 text-[13px] text-foreground', className)}>
      <span aria-hidden className="shrink-0">
        <LoadingSpinner size="sm" className="text-primary" />
      </span>
      <span>{children}</span>
    </div>
  )
}
